import React from "react";
import { Helmet } from "react-helmet";
import './classes/SmwwNewsPage.css';
import { keepLiveLinksOnSite } from "./liveSiteLinks";

// An SMWW News item at its own address (e.g. /content/<slug> for news copied from Drupal), which
// Page.js shows when no page has that address. As live's node page: only the body (the
// "Title (Frontend View)") in the centre column, the post name as the browser title, and the
// View / Edit tabs for admins. Links in the body typed with the live site's domain stay on this
// site.
const SmwwNewsPage = ({ news, isAdmin }) => (
    <div id="main" className="smww-news-page node-type-smww-news">
        <Helmet><title>{news.title}</title></Helmet>
        <div className="left"></div>
        <div className="center left-center">
            {isAdmin && (
                <ul className="tabs primarya">
                    <li className="active"><a href={news.link}>View</a></li>
                    <li><a href={"/smww-news/" + news.id + "/edit"}>Edit</a></li>
                </ul>
            )}
            <div id={"node-" + news.id} className="node node-smww-news node-promoted">
                <div className="content clearfix">
                    <div className="field field-name-body field-type-text-with-summary field-label-hidden">
                        <div className="field-items">
                            <div className="field-item even" dangerouslySetInnerHTML={{ __html: keepLiveLinksOnSite(news.body) }} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="right"></div>
    </div>
);

export default SmwwNewsPage;
